export const loadGoogleMaps = () => {
  window.mapReady = () => {};
  return new Promise((resolve) => {
    if (window.google && window.google.maps) {
      resolve(google.maps);
    } else if (window.loadingGoogleMaps) {
      window.mapReady = () => {
        resolve(google.maps);
      }
    } else {
      window.loadingGoogleMaps = true;
      $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyAZELwtBHpZOl5aJEU3oJYxciNUatPMppE&v=3.exp&callback=mapReady', function () {
        // Support 'current' property on markers globally.
        google.maps.Marker.prototype.setCurrent = function (current) {
          this.current = current;
          if (this.icon_focus) {
            if (current) {
              this.setIcon(this.icon_focus);
            } else {
              this.setIcon(this.icon_normal);
            }
          }
        };
        if (!google.maps.Polygon.prototype.getBounds) {
          google.maps.Polygon.prototype.getBounds = function () {
            var bounds = new google.maps.LatLngBounds();
            this.getPath().forEach(function (element, index) {
              bounds.extend(element);
            });
            return bounds;
          }
        }
        resolve(google.maps);
      });
    }
  });
}

export default loadGoogleMaps;